import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mobi/component-library/Common/V2/Buttons'
import { font, colors, spacing } from '@mobi/component-library/Theme/Common'
import image from '../../assets/images/trusted-device.png'

type Props = {
  /** Whether the loading state is active */
  isTrustDeviceEnabled: boolean
  /** Handler that will be invoked if the user wants their device to be trusted */
  onTrustDevice?: VoidFunction
  /** Handler that will be invoked if the user wants to skip trusting the device */
  onSkip?: VoidFunction
  /** override text on the primary tray button */
  primaryButtonText?: string
}

export const TrustedDevicePrompt: React.FC<Props> = ({
  isTrustDeviceEnabled,
  onTrustDevice,
  onSkip,
  primaryButtonText,
}) => {
  return (
    <WrapperStyled>
      <img src={image} alt='Mobile phone' />

      <h1>Is this your trusted device?</h1>

      <p>Add it as a trusted device to your TABtouch account for quicker, secure access.</p>

      <Button
        aria-label='Trust this device'
        isFullWidth
        disabled={!isTrustDeviceEnabled}
        onClick={onTrustDevice}
      >
        {primaryButtonText ?? 'Trust this device'}
      </Button>

      <Button aria-label='Skip' isFullWidth color='secondary_color' onClick={onSkip}>
        Skip for now
      </Button>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  alignItems: 'center',
  backgroundColor: colors.white,
  fontFamily: font.family.primary,

  '> img': { display: 'block', width: '100%', maxWidth: '370px', height: 'auto' },

  '> h1': {
    fontWeight: font.weight.semibold,
    fontSize: font.size.xl2.fontSize,
    letterSpacing: font.size.xl2.letterSpacing,
    lineHeight: font.size.xl2.lineHeight,
    margin: 0,
  },

  '> p': {
    fontWeight: font.weight.regular,
    fontSize: font.size.md.fontSize,
    letterSpacing: font.size.md.letterSpacing,
    lineHeight: font.size.md.lineHeight,
    color: colors.neutral[700],
    textAlign: 'center',
  },
})
